/**
 * Toast store — the imperative "say something brief" surface.
 *
 * GlobalToast renders these alongside its queue/arrival pills, so any page
 * can `useToastStore.getState().show('Couldn't load more')` without
 * hand-rolling local toast state (BUG-047: replaces native alert()s).
 */
import { create } from 'zustand';

export interface AppToast {
  id: number;
  message: string;
  type: 'success' | 'error';
}

interface ToastState {
  toasts: AppToast[];
  show: (message: string, type?: AppToast['type']) => void;
  dismiss: (id: number) => void;
}

let nextId = 1;

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  show: (message, type = 'success') => {
    const id = nextId++;
    set((state) => ({ toasts: [...state.toasts, { id, message, type }] }));
    setTimeout(() => {
      set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
    }, 3000);
  },
  dismiss: (id) =>
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) })),
}));
